import { COLORS } from './colors';
import { BREAKPOINTS, SPACING } from './spacing';
import { FONT_FAMILY, FONT_SIZE, FONT_WEIGHT } from './typography';

const theme = {
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  SPACING,
  BREAKPOINTS,
  transition: {
    default: '0.3s ease-in-out',
    fast: '0.1s ease-in-out',
  },
};

export default theme;
